const dateToday = new Date();
let monthCurrent = dateToday.getMonth();
let yearCurrent = dateToday.getFullYear();
const monthArray = [
  { value: 0, label: "January" },
  { value: 1, label: "February" },
  { value: 2, label: "March" },
  { value: 3, label: "April" },
  { value: 4, label: "May" },
  { value: 5, label: "June" },
  { value: 6, label: "July" },
  { value: 7, label: "August" },
  { value: 8, label: "September" },
  { value: 9, label: "October" },
  { value: 10, label: "November" },
  { value: 11, label: "December" },
];
var monthDropdown = document.getElementById("monthSelect");
var yearDropdown = document.getElementById("yearSelect");
var resultInfo = document.getElementById("resultInfo");
var resultsArea = document.getElementById("results");
var resultsArea2 = document.getElementById("results2");
for (const month of monthArray) {
  monthDropdown.innerHTML +=
    "<option value=" + month.value + ">" + month.label + "</option>";
}
for (var year = yearCurrent + 2; year > yearCurrent - 18; year--) {
  yearDropdown.innerHTML += "<option value=" + year + ">" + year + "</option>";
}
function handleSubmit() {
  resultInfo.innerHTML = "";
  var yearValue = null;
  resultsArea.innerHTML = "";
  resultsArea2.innerHTML = "";

  resultInfo.innerHTML =
    "Years of entry for children born in " +
    monthArray[monthDropdown.value].label +
    " " +
    yearDropdown.value;

  monthDropdown.value >= 4
    ? (yearValue = parseInt(yearDropdown.value) + 1)
    : (yearValue = parseInt(yearDropdown.value));
  var resultArray = [
    {
      name: "ELC Class 3<br /><small>(Contact our Enrolment Officer)</small>",
      value: yearValue + 3,
    },
    {
      name: "ELC Class 4 <br /><small>(Preschool)</small>",
      value: yearValue + 4,
    },
    { name: "Foundation", value: yearValue + 5 },
    { name: "Year 1", value: yearValue + 6 },
    { name: "Year 2", value: yearValue + 7 },
    { name: "Year 3", value: yearValue + 8 },
    { name: "Year 4", value: yearValue + 9 },
  ];
  var resultArray2 = [
    { name: "Year 5", value: yearValue + 10 },
    { name: "Year 6", value: yearValue + 11 },
    { name: "Year 7", value: yearValue + 12 },
    { name: "Year 8", value: yearValue + 13 },
    { name: "Year 9", value: yearValue + 14 },
    { name: "Year 10", value: yearValue + 15 },
    { name: "Year 11", value: yearValue + 16 },
    { name: "Year 12", value: yearValue + 17 },
  ];

  for (const result of resultArray) {
    resultsArea.innerHTML +=
      "<div class='enrolment__results-item'>" +
      "<div class='enrolment__results-item-head'>" +
      result.name +
      "</div> <div class='enrolment__results-item-year'>" +
      result.value +
      "</div>" +
      "</div>";
  }

  for (const result of resultArray2) {
    resultsArea2.innerHTML +=
      "<div class='enrolment__results-item'>" +
      "<div class='enrolment__results-item-head'>" +
      result.name +
      "</div> <div class='enrolment__results-item-year'>" +
      result.value +
      "</div>" +
      "</div>";
  }
}

// Exposed on window because it's invoked via an inline onclick attribute in
// templates/_blocks/enrolmentCalculator.twig, outside any module scope --
// ES modules are scoped by default, not global.
window.handleSubmit = handleSubmit;
